import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getToken } from '../../functions/app_functions.js';
import { format_date_technical } from '../../functions/functions_formatting.js';
import withRouter from '../../with_router.js';
import Userlist from './userlist.js';
import Triplist from './triplist.js';
import UserDetails from './userdetails.js';
import TripDetails from './tripdetails.js';


class AdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: [],
            tripdata: [],
            userdata_loaded: false,
            tripdata_loaded: false
        };

        // Define class methods
        this.loadUserData = this.loadUserData.bind(this);
        this.loadTripData = this.loadTripData.bind(this);
        this.setPage = this.setPage.bind(this);
        this.setUser = this.setUser.bind(this);
        this.setTrip = this.setTrip.bind(this);
        this.getAdminRoute = this.getAdminRoute.bind(this);
        this.flattenObject = this.flattenObject.bind(this);
        this.removeKeys = this.removeKeys.bind(this);
    }


    componentDidMount() {
        if (this.state.userdata.length <= 0) {
            this.loadUserData();
        }
        if (this.state.tripdata.length <= 0) {
            this.loadTripData();
        }
    }


    setPage(path = "") {
        if (!path || path === "dashboard") {
            this.props.navigate("/admin");
            return;
        }
        this.props.navigate("/admin/" + path);
    }


    setUser(user_id) {
        this.props.navigate("/admin/user/" + user_id);
    }


    setTrip(trip_id) {
        this.props.navigate("/admin/trip/" + trip_id);
    }


    getAdminRoute() {
        var pathname = (this.props.location && this.props.location.pathname) ? this.props.location.pathname : "/admin";
        var adminPath = pathname.startsWith("/admin") ? pathname.slice(6) : "";
        adminPath = adminPath.replace(/^\/+|\/+$/g, "");

        if (adminPath === "") {
            return { page: "landing" };
        }

        var parts = adminPath.split("/");
        if (parts.length === 1 && parts[0] === "users") {
            return { page: "users" };
        }
        if (parts.length === 1 && parts[0] === "trips") {
            return { page: "trips" };
        }
        if (parts.length === 2 && parts[0] === "user") {
            return { page: "user", id: parts[1] };
        }
        if (parts.length === 2 && parts[0] === "trip") {
            return { page: "trip", id: parts[1] };
        }
        return { page: "missing" };
    }


    async loadUserData() {
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/admingetuserdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                }
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.length >= 1) {
                // Set data to state
                data.sort((a, b) => new Date(b.created) - new Date(a.created));
                this.setState({
                    userdata: data.slice(0, 100),
                    userdata_loaded: true
                });
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not load user data. Please check the URL and try again.";
                this.props.setError(name, message);
                this.setState({
                    userdata_loaded: true
                });
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not load user data. Please check the URL and try again.";
            this.props.setError(name, message);
            this.setState({
                userdata_loaded: true
            });
            // Track event
            this.props.logEvent("Client error", "Logs_LoadData");
        }
    }


    async loadTripData() {
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/admingettripsdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                }
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.length >= 1) {
                // Set data to state
                data.sort((a, b) => new Date(b.updated[b.updated.length - 1]) - new Date(a.updated[a.updated.length - 1]));
                this.setState({
                    tripdata: data.slice(0, 100),
                    tripdata_loaded: true
                });
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not load trip data. Please check the URL and try again.";
                this.props.setError(name, message);
                this.setState({
                    tripdata_loaded: true
                });
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not load trip data. Please check the URL and try again.";
            this.props.setError(name, message);
            this.setState({
                tripdata_loaded: true
            });
            // Track event
            this.props.logEvent("Client error", "Logs_LoadData");
        }
    }


    flattenObject(obj, prefix = '', result = {}) {
        if (typeof obj !== 'object' || obj === null) {
            result[prefix] = obj;
            return result;
        }

        // Handle arrays
        if (Array.isArray(obj)) {
            if (obj.every(item => typeof item === 'object' && item !== null && !Array.isArray(item))) {
                // Array of objects → flatten
                obj.forEach((item, index) => {
                    this.flattenObject(item, `${prefix}[${index}]`, result);
                });
            } else {
                // Array of primitives or mixed → keep as-is
                result[prefix] = obj;
            }
            return result;
        }

        // Handle plain object
        Object.entries(obj).forEach(([key, value]) => {
            const newPrefix = prefix ? `${prefix}.${key}` : key;
            this.flattenObject(value, newPrefix, result);
        });

        return result;
    }


    removeKeys(obj, keysToRemove) {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
        );
    }


    render() {
        var route = this.getAdminRoute();
        var user = route.page === "user"
            ? this.state.userdata.filter(({ user_id }) => String(user_id) === String(route.id))[0]
            : null;
        var trip = route.page === "trip"
            ? this.state.tripdata.filter(({ trip_id }) => String(trip_id) === String(route.id))[0]
            : null;
        var usersPreview = [...this.state.userdata]
            .sort((a, b) => new Date(b.created || 0) - new Date(a.created || 0))
            .slice(0, 10);
        var tripsPreview = [...this.state.tripdata]
            .sort((a, b) => new Date(b.created || 0) - new Date(a.created || 0))
            .slice(0, 10);
        var tripsPerUser = this.state.tripdata.reduce((countMap, tripElement) => {
            var ownerId = String(tripElement.owner_id || "");
            if (!ownerId) {
                return countMap;
            }
            countMap[ownerId] = (countMap[ownerId] || 0) + 1;
            return countMap;
        }, {});

        return (
            <div className="content-container">
                <div className="content-wrapper">

                    <div className="admindashboard-container">
                        <div className="admindashboard__section__title text-title">
                            <Link to="/admin" className="text-link">Admin</Link>
                            {route.page === "users" && <span>{" / Users"}</span>}
                            {route.page === "trips" && <span>{" / Trips"}</span>}
                            {route.page === "user" &&
                                <span>
                                    {" / "}
                                    <Link to="/admin/users" className="text-link">Users</Link>
                                    {" / User " + route.id}
                                </span>
                            }
                            {route.page === "trip" &&
                                <span>
                                    {" / "}
                                    <Link to="/admin/trips" className="text-link">Trips</Link>
                                    {" / Trip " + route.id}
                                </span>
                            }
                            {route.page === "missing" && <span>{" / Missing page"}</span>}
                        </div>

                        {route.page === "landing" &&
                            <>
                                <div className="admindashboard__section">
                                    <div className="admindashboard__section__title text-title">
                                        Actions
                                    </div>
                                    <div className="admindashboard__section__content admindashboard__section__content--flex">
                                        <Link to="/admin/users" className="button button-large button-primary-light">
                                            Go to all users
                                        </Link>
                                        {" "}
                                        <Link to="/admin/trips" className="button button-large button-primary-light">
                                            Go to all trips
                                        </Link>
                                    </div>
                                </div>

                                <div className="admindashboard__section">
                                    <div className="admindashboard__section__title text-title">
                                        Recent activity overview
                                    </div>
                                    <div className="admindashboard__section__content admindashboard__section__content--grid-2">

                                        <div className="admindashboard__section__content__element">
                                            <div className="admindashboard__section__title text-title">
                                                Newest users
                                            </div>
                                            <div
                                                className="admindashboard__section__content__table admindashboard__section__content__table--adminuser"
                                            >
                                                <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                    Username
                                                </div>
                                                <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                    Full name
                                                </div>
                                                <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                    Country
                                                </div>
                                                <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                    Created
                                                </div>
                                                <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                    Trips
                                                </div>

                                                {usersPreview.map((userElement, i) => (
                                                    <React.Fragment key={i}>
                                                        <div onClick={() => this.setUser(userElement.user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                            {userElement.username || "-"}
                                                        </div>
                                                        <div onClick={() => this.setUser(userElement.user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                            {userElement.name || "-"}
                                                        </div>
                                                        <div onClick={() => this.setUser(userElement.user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                            {userElement.country || "-"}
                                                        </div>
                                                        <div onClick={() => this.setUser(userElement.user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                            {userElement.created ? format_date_technical(userElement.created) : "-"}
                                                        </div>
                                                        <div onClick={() => this.setUser(userElement.user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                            {tripsPerUser[String(userElement.user_id)] || 0}
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="admindashboard__section__content__element">
                                            <div className="admindashboard__section__title text-title">
                                                Newest trips
                                            </div>
                                            <div>
                                                <div
                                                    className="admindashboard__section__content__table admindashboard__section__content__table--admintrip"
                                                >
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Title
                                                    </div>
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Countries
                                                    </div>
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Rating
                                                    </div>
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Activities
                                                    </div>
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Views
                                                    </div>
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Owner
                                                    </div>
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Created
                                                    </div>
                                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                                        Last updated
                                                    </div>

                                                    {tripsPreview.map((tripElement, i) => (
                                                        <React.Fragment key={i}>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {tripElement.title || "-"}
                                                            </div>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {tripElement.countries && tripElement.countries.length >= 1 ? tripElement.countries.join(", ") : "-"}
                                                            </div>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {(tripElement.rate || tripElement.rate === 0) ? tripElement.rate : "-"}
                                                            </div>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {(tripElement.activities_count || tripElement.activities_count === 0) ? tripElement.activities_count : "-"}
                                                            </div>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {(tripElement.views || tripElement.views === 0) ? tripElement.views : "-"}
                                                            </div>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {tripElement.owner && tripElement.owner.username ? tripElement.owner.username : "-"}
                                                            </div>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {tripElement.created ? format_date_technical(tripElement.created) : "-"}
                                                            </div>
                                                            <div onClick={() => this.setTrip(tripElement.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                                {tripElement.updated && tripElement.updated.length >= 1 ? format_date_technical(tripElement.updated[tripElement.updated.length - 1]) : "-"}
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {route.page === "users" &&
                            <Userlist
                                userdata={this.state.userdata}
                                tripdata={this.state.tripdata}
                                setUser={this.setUser}
                                enableFilters={true}
                            />
                        }

                        {route.page === "trips" &&
                            <Triplist
                                tripdata={this.state.tripdata}
                                setTrip={this.setTrip}
                                enableFilters={true}
                            />
                        }

                        {route.page === "user" && !this.state.userdata_loaded &&
                            <div className="admindashboard__section">
                                <div className="admindashboard__section__content">
                                    Loading user data...
                                </div>
                            </div>
                        }

                        {route.page === "user" && this.state.userdata_loaded && !user &&
                            <div className="admindashboard__section">
                                <div className="admindashboard__section__title text-title">
                                    User not found
                                </div>
                                <div className="admindashboard__section__content">
                                    This user is not available in the current admin dataset.
                                    {" "}
                                    <Link to="/admin/users" className="text-link">
                                        Back to users
                                    </Link>
                                </div>
                            </div>
                        }

                        {route.page === "user" && this.state.userdata_loaded && user &&
                            <UserDetails
                                userdata={user}
                                tripdata={this.state.tripdata.filter((el) => String(el.owner_id) === String(route.id))}
                                setTrip={this.setTrip}
                                setUser={this.setUser}
                                flattenObject={this.flattenObject}
                                removeKeys={this.removeKeys}
                                loadUserData={this.loadUserData}
                                baseUrl={this.props.baseUrl}
                                apiTimeout={this.props.apiTimeout}
                                logEvent={this.props.logEvent}
                                setLoading={this.props.setLoading}
                                unsetLoading={this.props.unsetLoading}
                                setError={this.props.setError}
                                badges={this.props.badges}
                            />
                        }

                        {route.page === "trip" && !this.state.tripdata_loaded &&
                            <div className="admindashboard__section">
                                <div className="admindashboard__section__content">
                                    Loading trip data...
                                </div>
                            </div>
                        }

                        {route.page === "trip" && this.state.tripdata_loaded && !trip &&
                            <div className="admindashboard__section">
                                <div className="admindashboard__section__title text-title">
                                    Trip not found
                                </div>
                                <div className="admindashboard__section__content">
                                    This trip is not available in the current admin dataset.
                                    {" "}
                                    <Link to="/admin/trips" className="text-link">
                                        Back to trips
                                    </Link>
                                </div>
                            </div>
                        }

                        {route.page === "trip" && this.state.tripdata_loaded && trip &&
                            <TripDetails
                                tripdata={trip}
                                setUser={this.setUser}
                                flattenObject={this.flattenObject}
                                removeKeys={this.removeKeys}
                                loadTripData={this.loadTripData}
                                baseUrl={this.props.baseUrl}
                                apiTimeout={this.props.apiTimeout}
                                logEvent={this.props.logEvent}
                                setLoading={this.props.setLoading}
                                unsetLoading={this.props.unsetLoading}
                                setError={this.props.setError}
                                collections={this.props.collections}
                            />
                        }

                        {route.page === "missing" &&
                            <div className="admindashboard__section">
                                <div className="admindashboard__section__title text-title">
                                    Missing page
                                </div>
                                <div className="admindashboard__section__content">
                                    <Link to="/admin" className="text-link">
                                        Go to admin home
                                    </Link>
                                </div>
                            </div>
                        }

                    </div>

                </div>
            </div >
        )
    }
}

export default withRouter(AdminDashboard);
